import React, { useContext, useEffect, useState } from 'react';
import { Autocomplete } from '@material-ui/lab';
import { makeStyles, FormControl, TextField, CircularProgress } from '@material-ui/core';
import { PropTypes } from 'prop-types';
// import { useField } from 'formik';
import LanguageContext from '../../../contexts/languageContext';
import MessagesContext from '../../../contexts/messagesContext';
import { DropDownIcon } from '../Images/Icons';

const styles = makeStyles((theme) => ({
    rootFormControl: (props) => ({
        width: props.width ? props.width : '180px',
        paddingLeft: props.width !== '100%' && props.rootRtl ? '30px' : '0',
        paddingRight:
            (props.rootRtl && props.width !== '100%') || props.width === '100%' ? '0' : '30px',
        [theme.breakpoints.down(1025)]: {
            width: '100%',
            paddingLeft: 0,
            paddingRight: 0
        }
    }),
    label: {
        color: '#767676',
        paddingBottom: '8px'
    },
    autoCompleteRoot: {
        width: '100%'
    },
    input: {
        padding: '6px 5px 7px !important',
        lineHeight: '1.67em',
        height: '1.67em'
    },
    textFieldRoot: {
        '& label': {
            display: 'none'
        }
    },
    tag: {
        borderRadius: '9px',
        backgroundColor: '#d4e4fc',
        '& svg': {
            margin: '0px 5px 0px 0px !important',
            color: 'black'
        }
    },
    inputRoot: ({ disabled }) => ({
        border: 'solid 1px rgb(187,187,187)',
        opacity: disabled ? '0.5' : 1,
        backgroundColor: disabled ? '#fafbfc' : '#ffffff',
        // borderRadius: (props) => (props.isMobile ? '4px' : '9px'),
        fontSize: '16px',
        paddingRight: '0 !important',
        '&:focus-within': {
            border: 'solid 1px #1b90fa'
        }
    }),
    errorContainer: {
        padding: '3px 0px',
        fontSize: '0.9em',
        color: 'red',
        minHeight: '26px'
    },
    option: (props) => ({
        fontFamily: 'mainFont',
        fontSize: '14px',
        direction: props.optionsDirection === 'ltr' || !props.rootRtl ? 'ltr' : 'rtl',
        textAlign: props.optionsDirection === 'ltr' || !props.rootRtl ? 'ltr' : 'rtl'
    }),
    popupIndicator: {
        marginLeft: '5px'
    },
    endAdornment: (props) => ({
        left: props.rootRtl ? '10px' : 'auto',
        right: props.rootRtl ? 'auto' : '10px'
    }),
    loadingContainer: {
        marginInlineEnd: '5px',
        display: 'flex',
        alignItems: 'center'
    }
}));
export default function SearchableSelect(props) {
    const { hasValidation = true, loading = false } = props;
    // const [_, meta] = useField(props);
    const { lang } = useContext(LanguageContext);
    const { messages } = useContext(MessagesContext);
    const classes = styles({ ...props, rootRtl: lang === 'fa', disabled: props.disabledSituation });
    const [inputValue, setInputValue] = useState('');
    useEffect(() => {
        // setTouched(true);
        setValue(props.options?.find((val) => val.id?.toString() === props.value?.toString()));
        if (props.options?.find((val) => val.id?.toString() === props.value?.toString())) {
            setInputValue(props.options.find((val) => val.id === props.value)[props.optionsLabel]);
        }

        // return () => setTouched(false)
    }, [props.value, props.options, props.optionsLabel]);

    const [value, setValue] = useState(
        props.options?.find((val) => val.id?.toString() === props.value?.toString())
    );
    const handleChange = (newValue) => {
        setValue(newValue);
        props.setValue(newValue?.id, newValue?.name);
    };
    return (
        <FormControl classes={{ root: classes.rootFormControl }}>
            <label
                className={props.customClasses?.label || classes.label}
                htmlFor={props.id || props.name}
                id={props.id}
            >
                {props.label}
            </label>
            <Autocomplete
                disabled={props.disabledSituation}
                classes={{
                    root: classes.autoCompleteRoot,
                    inputRoot: props?.customClasses?.inputRoot || classes.inputRoot,
                    input: props?.customClasses?.input || classes.input,
                    option: props.customClasses?.option || classes.option,
                    popupIndicator: classes.popupIndicator,
                    endAdornment: props?.customClasses?.endAdornment || classes.endAdornment,
                    tag: classes.tag,
                    paper: props?.customClasses?.paper,
                    popper: props?.customClasses?.popper
                }}
                open={props?.openWithCustomInput}
                id={props.id}
                popupIcon={
                    props.customIcon ? (
                        props.customIcon
                    ) : (
                        <DropDownIcon width="24px" height="24px" fill="#bbb" />
                    )
                }
                options={props.options}
                getOptionLabel={(option) => option[props.optionsLabel]}
                inputValue={props.customInputValue || inputValue}
                onInputChange={(event, newInputValue) => {
                    setInputValue(newInputValue);
                }}
                value={props.customValue || value}
                loading={loading}
                onChange={(event, newValue) => {
                    handleChange(newValue);
                }}
                renderOption={props.renderOption}
                renderInput={(params) => (
                    <TextField
                        classes={{ root: classes.textFieldRoot }}
                        aria-labeledby={props.id}
                        // inputProps={{ 'aria-labelledby': `${props.id}` }}
                        {...params}
                        autoComplete="werty"
                        label={props.label}
                        InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                                <>
                                    {loading ? (
                                        <div className={classes.loadingContainer}>
                                            <CircularProgress size={20} />
                                        </div>
                                    ) : (
                                        params.InputProps.endAdornment
                                    )}
                                </>
                            )
                        }}
                    />
                )}
            />
            <div className={hasValidation && classes.errorContainer}>
                {props?.errors ? <span> {messages.required} </span> : null}
            </div>
        </FormControl>
    );
}
SearchableSelect.propTypes = {
    touched: PropTypes.any,
    label: PropTypes.string,
    id: PropTypes.any,
    name: PropTypes.string,
    options: PropTypes.array,
    optionsLabel: PropTypes.string,
    value: PropTypes.any,
    setValue: PropTypes.func,
    errors: PropTypes.any,
    dynamic: PropTypes.bool,
    disabledSituation: PropTypes.bool,
    optionalToUse: PropTypes.bool,
    optionsDirection: PropTypes.any,
    customClasses: PropTypes.object,
    hasValidation: PropTypes.bool,
    customIcon: PropTypes.any,
    customValue: PropTypes.string,
    customInputValue: PropTypes.string,
    openWithCustomInput: PropTypes.bool,
    loading: PropTypes.bool,
    renderOption: PropTypes.any
};
